import { computed, unref, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { isNil } from 'lodash-es';
import { useFieldValue } from 'vee-validate';

// Utility function for the field value logic
export default (
  fieldOrValue: string | Ref<boolean>,
  options: {
    activeText?: string;
    inactiveText?: string;
    nullText?: string;
  } = {},
) => {
  const { t } = useI18n();

  // Resolve either from useFieldValue (for string) or directly if it's a reactive boolean (Ref<boolean>)
  const value =
    typeof fieldOrValue === 'string'
      ? useFieldValue(fieldOrValue) // Resolve field value if it's a field name
      : fieldOrValue; // Use directly if it's a reactive boolean

  const valueText = computed(() => {
    const unRefValue = unref(value);
    if (!isNil(unRefValue)) {
      if (unRefValue) {
        return options.activeText || t('inputSwitch.active');
      } else {
        return options.inactiveText || t('inputSwitch.inactive');
      }
    } else {
      return options.nullText || '';
    }
  });

  return {
    valueText,
  };
};
